import { render } from "./TheSpinner.vue?vue&type=template&id=6d12dda8&scoped=true"
import script from "./TheSpinner.vue?vue&type=script&lang=js"
export * from "./TheSpinner.vue?vue&type=script&lang=js"

import "./TheSpinner.vue?vue&type=style&index=0&id=6d12dda8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d12dda8"]])

export default __exports__